import React from "react";
import {Link} from "gatsby";
import {navigate} from "gatsby-link";
import {FaChevronLeft, FaChevronRight} from 'react-icons/fa';
import SelectedIcon from "../../images/selected.svg";
import TravelledIcon from "../../images/travelled.svg";

import "../layout.css";
import "./formPage.css";
import "./button.css";

import Header from "../Header/header";
import ProgressBar from "../ProgressBar/progressBar";
import {saveUserInterest} from "../../apis";
import {pushContinueButtonTracking} from "../../apis/tracking";


class FormPage extends React.Component {
    constructor(props) {
        super(props);
        let {
            type,
            singlePage,
            contentIndex,
            resultData,
            cheerUpMessage,
            urlParam,
            searchBar,
            gridName,
            buttonType,
            buttonNext,
            buttonBack,
            doneButton,
            before,
            completed
        } = this.props;
        this.state = {
            type: type,
            singlePage: singlePage,
            title: '',
            intro: '',
            style: {
                searchBar: searchBar,
                gridName: gridName,
                buttonType: buttonType,
                buttonNext: buttonNext,
                buttonBack: buttonBack,
                doneButton: doneButton,
                barBefore: before,
                barCompleted: completed,
            },
            content: [],
            searchTerm: '',
            results: [],
            activeButton: [],
            destinationTrackingValues: {
                'Asia': [],
                'Europe': [],
                'Oceania': [],
                'North America': [],
                'South America': [],
                'Africa': []
            },
            cheerUpMessages: cheerUpMessage[0].content,
            activeCheerUpMessage: 0,
            urlParam: urlParam,
            additionalUrl: '',
            disableButtonContinue: true,
        }
        if (urlParam) {
            const newUrlParam = encodeURIComponent(urlParam);
            this.state.urlParam = newUrlParam;
            this.state.additionalUrl = "?ckel=" + newUrlParam;
        }

        const data = resultData[type];
        if (singlePage) {
            this.state.intro = resultData[singlePage][0].introtext[0][type];
            this.state.title = resultData[singlePage][1].question[0][type];
        } else {
            this.state.title = data[contentIndex - 1].question;
            if (data.length === 3) {
                this.state.intro = data[0].introtext;
            }
        }
        const content = data[contentIndex].content;

        for (let i = 0; i < content.length; i++) {
            if (content[i].color === 'transparent') {
                this.state.activeButton.push(content[i].text)
            }
        }
        this.state.content = content;
        this.state.results = content;
    }

    componentDidUpdate() {
        const content = this.state.content;
        const activeButton = this.state.activeButton;
        for (let i = 0; i < content.length; i++) {
            if (content[i].color === 'transparent' && content[i].category !== "Region") {
                if (activeButton.includes(content[i].text) === false) {
                    this.pushToActiveButton(content[i].text)
                    // this.updateTrackingValues('add', content[i])
                }
            }
        }
    }

    editSearchTerm = (e) => {
        this.pushTracking('Search', e.target.value)
        this.setState({searchTerm: e.target.value})
    }

    dynamicSearch = () => {
        return this.state.content.filter(
            result => {
                const query = this.state.searchTerm.toLowerCase();
                if (this.state.type === "TravelledPlace" || this.state.type === "BucketList") {
                    return (result.category.toLowerCase().indexOf(query) >= 0 || result.text.toLowerCase().indexOf(query) >= 0)
                } else {
                    return (result.text.toLowerCase().indexOf(query) >= 0)
                }
            }
        )
    }

    pushToActiveButton = (item) => {
        const newActiveButton = this.state.activeButton;
        newActiveButton.push(item);
        this.setState({
            activeButton: newActiveButton,
            disableButtonContinue: false,
        })
    }

    pushTracking = (action, item) => {
        typeof window !== "undefined" && window.gtmDataLayer.push({
            'event': 'trackEventNoEcommerce',
            'eventDetails.category': this.state.title,
            'eventDetails.action': action,
            'eventDetails.label': item,
        })
    }

    updateTrackingValues = (type, itemData) => {
        let newTrackingValues = this.state.destinationTrackingValues;
        if (type === 'add') {
            newTrackingValues[itemData.category].push(itemData.text)
        } else {
            const index = newTrackingValues[itemData.category].findIndex(
                value => value === itemData.text,
            );
            newTrackingValues[itemData.category].splice(index, 1)
        }
        this.setState({
            destinationTrackingValues: newTrackingValues,
        })
    }

    updateCheerUpMessage = (type) => {
        let index = Math.floor(1 + Math.random() * 5);
        if (type === 0) {
            index = 0;
        } else if (type === 6) {
            index = 6;
        }
        this.setState({
            activeCheerUpMessage: index,
        })
    }

    deleteFromActiveButton = (item) => {
        this.updateCheerUpMessage(6);
        let state = this.state;
        let newActiveButton = [...state.activeButton.filter(active => active !== item)];
        if (newActiveButton.length === 0) {
            this.setState({
                disableButtonContinue: true,
            });
            this.updateCheerUpMessage(0);
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.activeButton = newActiveButton;
    }

    findData = (data, item, key) => {
        return data.filter(
            function (data) {
                return data[key] === item
            }
        );
    }

    saveForm = event => {
        event.preventDefault();
        const category = this.state.type;
        const urlParam = this.state.urlParam;
        const nextPage = this.state.style.buttonNext;
        const payload = {
            category: category,
            values: this.state.activeButton,
        }

        if (urlParam) {
            saveUserInterest(urlParam, payload).then(r => {
                console.log("Submitted: ", r);
            })
        }
        pushContinueButtonTracking(category, this.state.activeButton, this.state.destinationTrackingValues);
        navigate(nextPage + this.state.additionalUrl);
    }

    changeButtonColor = (index, color) => {
        const cards = this.state.content;
        index = cards.findIndex(
            card => card.text === index,
        );
        if (color === 'transparent') {
            cards[index].color = '#f37160'
            this.deleteFromActiveButton(cards[index].text);
            if (cards[index].category) {
                this.updateTrackingValues('remove', cards[index]);
            }
        } else {
            cards[index].color = 'transparent';
            this.pushToActiveButton(cards[index].text);
            this.pushTracking('click', cards[index].text);
            if (cards[index].category) {
                this.updateTrackingValues('add', cards[index])
            }
            this.updateCheerUpMessage(1);
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.content = cards;
        this.forceUpdate();
        return this.renderCards(cards);
    }

    chooseAll = (region) => {
        const cards = this.state.content;
        const index = cards.findIndex(
            card => card.text === region,
        );

        if (cards[index].color === 'transparent') {
            cards[index].color = '#f37160';
            for (let i = index + 1; i < cards.length; i++) {
                if (cards[i].category === region) {
                    cards[i].color = '#f37160';
                    this.deleteFromActiveButton(cards[i].text);
                    this.updateTrackingValues('remove', cards[i])
                } else {
                    break;
                }
            }
        } else {
            cards[index].color = 'transparent';
            for (let i = index + 1; i < cards.length; i++) {
                if (cards[i].category === region) {
                    if (cards[i].color !== 'transparent') {
                        cards[i].color = 'transparent';
                        this.pushToActiveButton(cards[i].text);
                        this.updateTrackingValues('add', cards[i])
                    }
                } else {
                    break;
                }
            }
            this.updateCheerUpMessage(1);
            this.pushTracking('click', 'All ' + region);
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.content = cards;
        this.forceUpdate();
        this.renderCards(cards);
    }

    renderCards = (data) => {
        const cards = data;
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.results = cards;
        return cards.map(this.renderButton)
    }

    renderButton = (card) => {
        const {cardClass, imageClass, buttonClass} = this.props;
        const index = card.text;
        if (card.category === "Region") {
            return (
                <div key={index} className="RegionContainer">
                    <input name={index} type="checkbox" id={index} value={card.text}
                           checked={this.state.destinationTrackingValues[card.text].length >= card.total || card.color === 'transparent'}
                           onChange={this.chooseAll.bind(this, index)}/>
                    <label htmlFor={index} className="RegionLabelContainer">
                        <h3 className="Region">{index}</h3>
                        <div className="ChooseAll">{card.color === 'transparent' ? 'Remove All' : 'Choose All'}</div>
                    </label>
                </div>
            )
        } else {
            return (
                <div key={index} className={cardClass}>
                    <input name={index} type="checkbox" id={index} value={card.text}
                           checked={card.color === 'transparent'}
                           onChange={this.changeButtonColor.bind(this, index, card.color)}/>
                    <label htmlFor={index}>
                        <div className={buttonClass + "Icon"}>
                            <img className="SelectedIcon" alt="Selected Icon"
                                 src={this.state.type === 'TravelledPlace' ? TravelledIcon : SelectedIcon}/>
                        </div>
                        <div className={buttonClass}/>
                        <img className={imageClass} src={card.imageUrl} alt={card.text} title={card.text}
                             style={{}}/>
                        <p className="CardText">{card.text}</p>
                    </label>
                </div>
            )
        }
    }

    render() {
        const {
            singlePage,
            intro,
            title,
            content,
            activeButton,
            additionalUrl,
            cheerUpMessages,
            activeCheerUpMessage
        } = this.state;
        const {searchBar, gridName, buttonType, buttonBack, doneButton, barBefore, barCompleted} = this.state.style;
        return (
            <>
                <form className="Container">
                    <div className="StickyHeader">
                        <Header siteTitle={title} siteIntro={intro}
                                cheerUpMessage={cheerUpMessages[activeCheerUpMessage].text}/>
                        {searchBar === true && (
                            <>
                                <input className="SearchBar" type='text' value={this.state.searchTerm}
                                       onChange={this.editSearchTerm}
                                       placeholder='Search a country or region'/>
                                <hr className="SearchBarLine"/>
                            </>
                        )}
                    </div>
                    <br/>
                    {searchBar === true && (
                        <div className="GridBox">
                            {this.renderCards(this.dynamicSearch())}
                        </div>
                    )}
                    {searchBar === false && (
                        <div className={gridName}>
                            {this.renderCards(content)}
                        </div>
                    )}
                    <div className="GridButton">
                        {buttonType === "WithBackButton" && (
                            <Link to={buttonBack + additionalUrl}>
                                <button className="ButtonBack"><FaChevronLeft className="Arrow"/> </button>
                            </Link>
                        )}
                        {buttonType !== "WithBackButton" && (
                            <div/>
                        )}
                        {doneButton && (
                            <button type="submit" className="ButtonContinue" disabled={activeButton.length === 0}
                                    onClick={this.saveForm}>Done</button>
                        )}
                        {!doneButton && (
                            <button type="submit" className="ButtonContinue"
                                    disabled={activeButton.length === 0}
                                    onClick={this.saveForm}>Continue <FaChevronRight
                                className="Arrow"/></button>
                        )}
                    </div>
                    {!singlePage && (
                        <ProgressBar before={barBefore} completed={barCompleted}/>
                    )}
                </form>
            </>
        );
    }
}

export default FormPage;
